import LocationOnIcon from "@mui/icons-material/LocationOn";
import { Box, Typography, Grid } from "@mui/material";

export const UpcomingTrips = () => {
    return (
        <Box maxWidth="xl">
            <Typography
                variant="h6"
                className="trp"
                sx={{
                    fontSize: "14px",
                    marginBottom: "2%"
                }}
            >
                Upcoming Trips
            </Typography>

            <Grid container spacing={2}>
                {[1, 2].map((item) => (
                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6} key={item}>
                        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <img src={require(`../../assets/images/image.png`)} alt="trip" style={{ width: "100%" }} />
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", margin: "10px" }}>
                                <LocationOnIcon sx={{ color: "#7159EA" }} className="inline" />
                                <Typography variant="h5" className="inline title" sx={{ marginLeft: "5px" }}>
                                    New York
                                </Typography>
                            
                            <Box sx={{ display: "flex", }} className="ml-32">
                                {[1, 2, 3].map((avatar) => (
                                    <img
                                        key={avatar}
                                        src={require(`../../assets/images/${avatar}.png`)}
                                        alt="avatar"
                                        className="inline"
                                        style={{ width: "20%", marginRight: "-5px" }}
                                    />
                                ))}
                                <img
                                    src={require("../../assets/images/plus1.png")}
                                    alt="avatar"
                                    className="inline bg-pry"
                                    style={{ width: "20%", marginRight: "-5px" }}
                                />
                            </Box>
                        </Box>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};
